import { createStore } from 'vuex';

import conversationalAi from './modules/conversationalAi';
import code from './modules/code';
import onboarding from './modules/onboarding';
import aicoding from './modules/aicoding';
import memo from './modules/memo';
import notification from './modules/notification';
import project from './modules/project';
import source from './modules/source';
import group from './modules/group';
import report from './modules/report';
import user from './modules/user';
import modal from './modules/modal';
import tracking from './modules/tracking';
import gridUtil from './modules/gridUtil';
import globalSearch from './modules/globalSearch';
import gridWrap from './modules/gridWrap';

const { plugins: globalSearchInitPlugins, ...globalSearchStore } = globalSearch;
const { plugins: gridWrapStorePlugins, ...gridWrapStore } = gridWrap;

export default createStore({
  modules: {
    conversationalAi,
    code,
    onboarding,
    aicoding,
    memo,
    notification,
    project,
    source,
    group,
    report,
    user,
    modal,
    tracking,
    globalSearch: globalSearchStore,
    gridWrap: gridWrapStore,
    gridUtil,
  },
  plugins: [...gridWrapStorePlugins, ...globalSearchInitPlugins],
});
